var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"look-dialog",attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":"600px","before-handleClose":_vm.handleClose,"handleClose-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"look-one"},[_c('Content',{attrs:{"text":_vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }